import sanitizeRelativeUrl from "common/utils/sanitizeRelativeUrl";
import { getExperiments } from "js/core/services/experiments";

type RedirectLocation = Pick<Location, "href" | "pathname" | "reload">;

interface HandleSuccessfulCheckoutRedirectOptions {
    location?: RedirectLocation;
    search?: string;
}

async function getSuccessfulCheckoutEndUrl() {
    try {
        const experiments = await getExperiments(["workspace_entry_generate_with_ai"]);
        const workspaceEntryGenerateWithAi = experiments.workspace_entry_generate_with_ai?.enabled ?? false;

        return workspaceEntryGenerateWithAi ? "/create-presentation/generate-with-ai?hideSidebar" : "/";
    } catch {
        // getExperiments already logs failures; keep the default false redirect behavior.
        return "/";
    }
}

export async function handleSuccessfulCheckoutRedirect({
    location = window.location,
    search = window.location.search,
}: HandleSuccessfulCheckoutRedirectOptions = {}) {
    const endUrl = await getSuccessfulCheckoutEndUrl();
    const continueUrl = sanitizeRelativeUrl(new URLSearchParams(search).get("continue") ?? endUrl);

    // If the continue URL is the same as the current URL, force a reload to refresh subscription state.
    if (continueUrl !== location.pathname) {
        location.href = continueUrl;
        return;
    }

    location.reload();
}
